module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"short_name":"remaxCapital","name":"REMAX Capital","description":"Your go-to real estate brokerage for excellent agents and properties","start_url":"/","background_color":"#00359B","theme_color":"#00359B","display":"standalone","icon":"src/assets/logos/remax-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"aed35d7aa18a29a987c68fc4a79077a7"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
